<script lang="ts">
    import 'ol/ol.css';
    import Map from 'ol/Map';
    import Overlay from 'ol/Overlay';
    import View from 'ol/View';
    import Feature from 'ol/Feature';
    import Point from 'ol/geom/Point';
    import { fromLonLat, toLonLat,getPointResolution } from 'ol/proj';
    import { Circle as CircleStyle, Stroke, Style, Fill, Text } from 'ol/style';
    import { OSM, Vector as VectorSource } from 'ol/source';
    import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
    import {fromExtent} from "ol/geom/Polygon";
    import {addSearchNearTask} from "../Utils"
    import {DateTime} from "luxon";
    import type {SearchNearTaskPoint, SearchNearTaskSquare} from "../Types";
    export const params = {}
    let map = null;
    let viewDiv = "map";
    let showPreloader: boolean = false;
    let searchDistance: number = 1000;
    let widthInMeters: number = 3000;
    let heightInMeters: number = 3000;
    let name: string = "Пошук за: " + DateTime.now().toFormat("yyyy-MM-dd HH:mm");
    let square: SearchNearTaskSquare | null = null;
    let taskId: string| null = null;

    let layer = new TileLayer({
        source: new OSM(),
    });
    let sourcePolygon = new VectorSource({
        wrapX: false,
    });
    let vectorPolygon = new VectorLayer({
        source: sourcePolygon,
    });
    let stylePositions = new Style({
        image: new CircleStyle({
            fill: new Fill({
                color: 'rgba(55, 200, 150, 0.5)',
            }),
            stroke: new Stroke({
                width: 2,
                color: 'rgba(255, 5, 5, 1)',
            }),
            radius: 7,
        }),
    });

    let source = new VectorSource({
        wrapX: false,
    });
    let vector = new VectorLayer({
        source: source,
        style: stylePositions,
    });

    const setupMap = (node, _id) => {
        let center = fromLonLat(["31.2858", "49.0139"]);
        map = new Map({
            layers: [layer],
            target: _id,
            view: new View({
                center: center,
                zoom: 11,
            }),
        });

        map.addLayer(vector);
        map.addLayer(vectorPolygon);

        return {
            destroy() {
                if (map) {
                    map.setTarget(null);
                    map = null;
                }
            }
        }
    }
    function drawNet() {
        source.clear();
        sourcePolygon.clear();
        square = null;

        let centerCoordinate = map.getView().getCenter();
        let pointRes = getPointResolution(map.getView().getProjection(), 1, centerCoordinate);
        let widthInUnits = widthInMeters / pointRes;
        let heightInUnits = heightInMeters / pointRes;
        let minX = centerCoordinate[0] - widthInUnits / 2;
        let minY = centerCoordinate[1] - heightInUnits / 2;
        let maxX = centerCoordinate[0] + widthInUnits / 2;
        let maxY = centerCoordinate[1] + heightInUnits / 2;
        let mapExtent = [
            minX,
            minY,
            maxX,
            maxY
        ];
        let region = fromExtent(mapExtent);

        let feature = new Feature(region);
        sourcePolygon.addFeature(feature);
        square = {
            name: name,
            centerX: centerCoordinate[0],
            centerY: centerCoordinate[1],
            minX: minX,
            minY: minY,
            maxX: maxX,
            maxY: maxY,
            width: widthInMeters,
            height: heightInMeters,
            search_distance: searchDistance,
            finished_at: null,
            points: []
        }
        let columnPoints = Math.floor(heightInMeters/searchDistance);
        let rowPoints = Math.floor(widthInMeters/searchDistance);
        let previousPointX = minX;
        let previousPointY = minY;

        for (let i = 0; i <= columnPoints; i++) {
            for (let j = 0; j <= rowPoints; j++) {
                let geom = new Point([previousPointX, previousPointY]);
                let lonLat = toLonLat([previousPointX, previousPointY]);
                square.points.push({
                    'x': previousPointX,
                    'y': previousPointY,
                    'lat': lonLat[1],
                    'lon': lonLat[0],
                } as SearchNearTaskPoint)
                let featurePoint = new Feature(geom);
                sourcePolygon.addFeature(featurePoint);
                let pointRes = getPointResolution(map.getView().getProjection(), 1, [previousPointX, previousPointY]);
                previousPointX += searchDistance / pointRes;
            }
            previousPointX = minX;
            previousPointY += searchDistance / pointRes;
        }
        if (square.points.length > 20) {
            alert('Зменшіть зону пошуку, дозволено лише 20 точок пошуку');
            source.clear();
            sourcePolygon.clear();
            square = null;
        }
    }
    function resetNet() {
        source.clear();
        sourcePolygon.clear();
        square = null;
    }

    async function startSearch() {
        if (square.points.length < 1 || square.points.length > 20) {
            alert('Вкажіть зону пошуку. Необхідно намалювати сітку');
            return;
        }

        if (square.points.length > 20) {
            alert('Зменшіть зону пошуку, дозволено лише 20 точок пошуку');
            source.clear();
            sourcePolygon.clear();
            square = null;
            return;
        }
        showPreloader = true;
        let addSearchNearTaskResponse = await addSearchNearTask(square);

        if (addSearchNearTaskResponse != null) {
            source.clear();
            sourcePolygon.clear();
            square = null;
            taskId = addSearchNearTaskResponse.task_id;
            showPreloader = false;
        }
    }

    let widthErrorClass = '';
    let heightErrorClass = '';
    let searchDistanceErrorClass = '';
    let nameErrorClass = '';
    let isDisabledButton = false;

    $: {
        isDisabledButton = false;
        if (!name || name.length < 1) {
            nameErrorClass = 'is-invalid'
            isDisabledButton = true;
        } else {
            nameErrorClass = '';
        }
        if (!widthInMeters || widthInMeters > 10000 || widthInMeters < 1000) {
            widthErrorClass = 'is-invalid'
            isDisabledButton = true;
        } else {
            widthErrorClass = ''
        }
        if (!heightInMeters || heightInMeters > 10000 || heightInMeters < 1000) {
            heightErrorClass = 'is-invalid'
            isDisabledButton = true;
        } else {
            heightErrorClass = ''
        }
        if (!searchDistance ||
            searchDistance > 5000 ||
            searchDistance < 500 ||
            searchDistance > widthInMeters ||
            searchDistance > heightInMeters
        ) {
            searchDistanceErrorClass = 'is-invalid'
            isDisabledButton = true;
        } else {
            searchDistanceErrorClass = ''
        }
    }
</script>
<style>
    #sidebar {
        height: 100vh;
        width: 30%;
        float: left;
        text-align: center;
    }

    #settings {
        padding: 20px;
        height: 15vh;
    }

    #map {
        width: 70%;
        height: 100vh;
        overflow: hidden;
        position: relative;
    }
    .center {
        width: 16px;
        height: 18px;
        position: absolute;
        margin-top: -9px;
        margin-left: -8px;
        top: 50%;
        left: 50%;
        z-index: 100;
    }
</style>
<div id="sidebar">
    <div id="settings">
        {#if showPreloader === true}
            <div class="spinner-grow"></div>
        {/if}
        <div class="row">
            <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">Назва</span>
                </div>
                <input type="text" class="form-control name {nameErrorClass}" bind:value={name} required>
            </div>

            <div class="input-group input-group-sm mb-3 settings-width">
                <div class="input-group-prepend">
                    <span class="input-group-text">Ширина квадрату (метрів)</span>
                </div>
                <input type="number" min="1000" max="10000" class="form-control polygonWidth {widthErrorClass}" bind:value={widthInMeters} required>
            </div>
            <div class="input-group input-group-sm mb-3 settings-height">
                <div class="input-group-prepend">
                    <span class="input-group-text">Довжина квадрату (метрів)</span>
                </div>
                <input type="number" min="1000" max="10000" class="form-control polygonHeight {heightErrorClass}" bind:value={heightInMeters} required/>
            </div>
            <div class="input-group input-group-sm mb-3 settings-distance">
                <div class="input-group-prepend">
                    <span class="input-group-text">Крок сітки (метрів)</span>
                </div>
                <input type="number" min="500" max="5000" name="searchDistance" class="form-control searchDistance {searchDistanceErrorClass}" bind:value={searchDistance} required/>
            </div>
        </div>
        <input type="button" value="Очистити точки пошуку" class="btn btn-danger" on:click={resetNet}/>
        <input type="button" disabled="{isDisabledButton}" value="Намалювати сітку" class="btn btn-info" on:click={drawNet} />
        <input type="button" disabled="{isDisabledButton}" value="Почати пошук" class="btn btn-success" on:click={startSearch} />
        {#if taskId != null}
            <div class="alert alert-info mt-3">
                <div class="alert-heading">
                    <p>Cтворена завдання на пошук із ID: </p>
                </div>
                <hr>
                <p class="mb-1"><strong>{taskId}</strong></p>
            </div>
        {/if}
    </div>
</div>
<div id={viewDiv} class="map" use:setupMap={viewDiv}>
    <div id="mapExtensions">
        <div class="center">
            <i class="bi bi-pin-map"></i>
        </div>
    </div>
</div>